import { createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "800px",
  height: "800px",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("defs", null, [
      (_openBlock(), _createBlock(_resolveDynamicComponent("style"), null, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createTextVNode(".cls-1{fill:#669df6;}.cls-1,.cls-2{fill-rule:evenodd;}.cls-2{fill:#4285f4;}", -1)
        ]))]),
        _: 1
      }))
    ]),
    _cache[1] || (_cache[1] = _createElementVNode("title", null, "Icon_24px_AppigeeAPIPlatform_Color", -1)),
    _cache[2] || (_cache[2] = _createElementVNode("g", { "data-name": "Product Icons" }, [
      _createElementVNode("g", null, [
        _createElementVNode("g", null, [
          _createElementVNode("path", {
            id: "Fill-1",
            class: "cls-1",
            d: "M5.2,12l1.32-1.32L4.73,8.89a2.94,2.94,0,0,1,2.08-5,2.92,2.92,0,0,1,2.07.86l1.8,1.79L12,5.2,10.21,3.41a4.81,4.81,0,1,0-6.8,6.8Z"
          }),
          _createElementVNode("path", {
            id: "Fill-3",
            class: "cls-1",
            d: "M18.8,12l-1.32,1.32,1.79,1.8a2.94,2.94,0,0,1-4.16,4.15l-1.79-1.79L12,18.8l1.79,1.79a4.81,4.81,0,1,0,6.8-6.8Z"
          }),
          _createElementVNode("g", null, [
            _createElementVNode("path", {
              id: "Fill-5",
              class: "cls-2",
              d: "M8.89,19.27a2.94,2.94,0,0,1-4.16-4.16l1.79-1.79,4.16,4.16ZM15.12,4.73a2.93,2.93,0,0,1,5,2.08,3,3,0,0,1-.86,2.08l-1.79,1.79L13.32,6.52ZM12,15.19A3.2,3.2,0,0,1,8.81,12h0A3.21,3.21,0,0,1,12,8.81h0A3.21,3.21,0,0,1,15.19,12h0A3.2,3.2,0,0,1,12,15.19ZM18.8,12l1.79-1.79a4.81,4.81,0,1,0-6.8-6.8L12,5.2,5.2,12,3.41,13.79a4.81,4.81,0,1,0,6.8,6.8L12,18.8Z"
            })
          ])
        ])
      ])
    ], -1))
  ]))
}
export default { render: render }